export default __webpack_public_path__ + "static/media/button-spinner.2f7e3f1c.svg";